module.exports = {
    "id": "portal",
    "title": "portal",
    "icon": "portal",
    "color": "blue",
    "description": "",
    "category": "rules",
    "searchTags": ["teleport","appear"],
    "exposedVariables": [
        {
            "variableName": "destination sprite",
            "spriteName": "$glitch_target",
            "tooltip": "Set the piece that this piece will teleport to",
            "input": {
                "type": "sprite"
            },
            "value": "none"
        }
    ],
    "info": [
        {
            "text": "Make a piece turn into a portal that leads to another piece",
            "image": "provision/glitches/portal/portal.gif"
        }
    ],
    "codeImage": "provision/glitches/teleport/teleport.png",
    "code": null,
    "zip": null,
    "sb3": null,
    "isRemix": true
};